export enum RememberType {
  LocalStorage,
  SessionStorage,
  DontPersist,
}

export const CLASS_SELECTION_PARAM = 'classSelection';
